<template>
  <b-row>
    <b-col lg="3" md="4" sm="5">
      <div class="field">
        <CustomDropdown :required-icon="true" :label="$t('5005.supplier')" v-model="SupformData.SupplierId"
          :disabled="disabled" :rules="{ required: false }" name="Supplier Name" id="Supplier Name" :items="supcategory"
          :showClear="false" @change="$emit('emitsupplierval')" @update:modelValue="
            getfindonedata, $emit('SupplierId', SupformData.SupplierId)
            " />
      </div>
    </b-col>
    <!-- <b-col lg="3" md="4" sm="6" v-if="displayterms">
      <div class="field">
        <CustomDropdown :label="$t('5005.paymentterms.terms')" v-model="SupformData.PaymentTermsId" name="PAYMENT TERMS"
          id="PAYMENT TERMS" :items="paymentcategory" @update:modelValue="PaymentFunction" />
      </div>
    </b-col> -->
    <b-col lg="3" md="4" sm="6" v-if="displayterms">
      <div class="field">
        <CustomDropdown :label="$t('5005.DeliveryTerms')" v-model="SupformData.DeliveryTermsId" name="DELIVERY TERMS"
          id="DELIVERY TERMS" :items="deliverycategory" @update:modelValue="DeliveryFunction" />
      </div>
    </b-col>
    <b-col lg="3" md="4" sm="6" v-if="displayterms">
      <div class="field">
        <CustomDropdown :label="$t('5005.WarrantyTerms')" v-model="SupformData.WarrantyTermsId" name="WARRANT TERMS"
          id="WARRANT TERMS" :items="WarrantyTermsOption" @update:modelValue="WarrantyTermsOnChange" />
      </div>
    </b-col>
  </b-row>

  <div v-if="Param != 'PO' && Param != 'POAmendment'">
    <b-row v-if="SupplierCard">
      <b-col xl="6" lg="6" md="8" sm="12" cols="12" class="p-0">
        <div class="d-flex align-items-baseline">
          <div class="SupplierCard">
            <div class="suppliercardcontent">
              <b-row class="p-3">
                <b-col xl="10" lg="10" md="10" sm="10" cols="10">
                  <h6>{{ SupformData.SupplierName }}</h6>
                  <p class="py-3" v-if="Data.Address">{{ Data.Address }}</p>
                </b-col>

                <b-col class="d-flex flex-row-reverse" xl="2" lg="2" md="2" sm="2" cols="2">
                  <!-- <p>
                    <i class="pi pi-external-link" style="color: #0a82ff; cursor: pointer" @click="RowClick"></i>
                  </p> -->
                  <p v-if="Param == 'PO'">
                    <i class="pi pi-trash me-2" style="color: red" @click="DeleteSupplier()"></i>
                    <i class="pi pi-pencil me-2" @click="EditSupDet = !EditSupDet"></i>
                  </p>
                </b-col>
              </b-row>
              <b-row class="p-3" v-if="cardshow">
                <b-col>
                  <h6>{{ $t("5005.paymentterms.terms") }}</h6>
                  <div class="contentbg" v-if="!EditSupDet">
                    <p>
                      {{ removeHtmlTags(SupformData.PaymentTermsName) }}
                    </p>
                  </div>
                  <div class="label-d-none field" v-else>
                    <!-- <TextEditor v-model="SupformData.PaymentTermsName" name="PaymentTextarea" label=""
                      :rules="{ required: false }" id="PaymentTextarea" ref="PaymentTextarea" /> -->

                    <Textarea name="paymentTextarea" label="" :rules="{ required: false }" id="paymentTextarea"
                      v-model="SupformData.PaymentTermsName" />
                  </div>
                </b-col>
                <b-col>
                  <h6>{{ $t("5005.DeliveryTerms") }}</h6>
                  <div class="contentbg" v-if="!EditSupDet">
                    <p>{{ removeHtmlTags(SupformData.DeliveryTermsName) }}</p>
                  </div>
                  <div class="label-d-none field" v-else>
                    <!-- <TextEditor v-model="SupformData.DeliveryTermsName" name="deliveryTextarea" label=""
                      :rules="{ required: false }" id="deliveryTextarea" ref="deliveryTextarea" /> -->

                    <Textarea name="deliveryTextarea" label="" :rules="{ required: false }" id="deliveryTextarea"
                      v-model="SupformData.DeliveryTermsName" />
                  </div>
                </b-col>
              </b-row>
              <b-row class="p-3" v-if="cardshow">
                <b-col>
                  <h6>{{ $t("5005.WarrantyTerms") }}</h6>
                  <div class="contentbg" v-if="!EditSupDet">
                    <p>{{ removeHtmlTags(SupformData.WarrantyTermsName) }}</p>
                  </div>
                  <div class="label-d-none field" v-else>
                    <!-- <TextEditor v-model="SupformData.WarrantyTermsName" name="warrantyTextarea" label=""
                      :rules="{ required: false }" id="warrantyTextarea" ref="warrantyTextarea" /> -->

                    <Textarea name="warrantyTextarea" label="" :rules="{ required: false }" id="warrantyTextarea"
                      v-model="SupformData.WarrantyTermsName" />
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="SupplierCardgst p-3 mt-3">
              <b-row>
                <b-col class="d-flex align-items-center">
                  <span>{{ $t("5005.gst") }}:</span>
                  <span>{{ Data.GST }}</span>
                </b-col>
                <b-col class="d-flex flex-row-reverse" v-if="Data.GST !== ''">
                  <p class="mb-0">
                    <i ref="copyButton" class="pi pi-copy copyicon" v-b-tooltip="{
                      title: tooltipContent,
                      triggers: ['hover', 'focus'],
                    }" @click="copyGST"></i>
                  </p>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <div v-else>
    <b-row v-if="SupplierCard">
      <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="p-0">
        <div class="d-flex align-items-baseline">
          <div class="SupplierCard">
            <div class="suppliercardcontent">
              <b-row class="p-3">
                <b-col xl="10" lg="10" md="10" sm="10" cols="10">
                  <h6>{{ SupformData.SupplierName }}</h6>
                  <p class="py-3" v-if="Data.Address">{{ Data.Address }}</p>
                </b-col>
                <b-col class="d-flex flex-row-reverse" xl="2" lg="2" md="2" sm="2" cols="2">
                  <!-- <p>
                    <i
                      class="pi pi-external-link"
                      style="color: #0a82ff; cursor: pointer"
                      @click="RowClick"
                    ></i>
                  </p> -->
                  <i class="pi pi-trash me-2" style="color: red" @click="DeleteSupplier()"></i>
                  <i class="pi pi-pencil me-2" @click="EditSupDet = !EditSupDet"></i>
                </b-col>
              </b-row>

              <b-row class="p-3" v-if="cardshow" v-for="(Payment, index) in MultiplePayment" :key="index">
                <b-col xl="2" lg="2" md="2" sm="2" cols="2">
                  <div class="field">
                    <CustomDropdown :label="$t('5005.paymentterms.terms')" :name="$t('5005.paymentterms.terms') + index"
                      :id="$t('5005.paymentterms.terms') + index" v-model="Payment['PayTermsId']" name="PAYMENT TERMS"
                      id="PAYMENT TERMS" :items="paymentcategory" @update:modelValue="
                        MultiplePaymentFunction(index, Payment['PayTermsId'])
                        " :required-icon="true" />
                  </div>
                </b-col>

                <b-col xl="4" lg="4" md="4" sm="2" cols="4">
                  <label>{{ $t("5005.description") }}</label>
                  <div class="contentbg" v-if="Payment['IsEdit']">
                    <p>
                      {{ removeHtmlTags(SupformData.PaymentTermsName) }}
                    </p>
                  </div>
                  <div v-else class="label-d-none field">
                    <!-- <TextEditor v-model="Payment['Description']" :name="$t('5005.description') + index"
                      :label="$t('5005.description')" :rules="{ required: false }" :id="$t('5005.description') + index"
                      ref="description" /> -->

                    <Textarea :name="$t('5005.description') + index" :label="$t('5005.description')"
                      :rules="{ required: false }" :id="$t('5005.description') + index" v-model="Payment['Description']"
                      ref="description" />
                  </div>
                </b-col>
                <b-col xl="1" lg="1" md="1" sm="1" cols="1">
                  <TextField :name="$t('5005.percentage') + index" :id="$t('5005.percentage') + index"
                    :label="$t('5005.percentage')" :rules="{ required: false, decimal: true }"
                    v-model="Payment['Percentage']" @keyup="ChangeAmount(index)" />
                </b-col>
                <b-col xl="2" lg="2" md="2" sm="2" cols="2">
                  <TextField :name="$t('5005.amount') + index" :id="$t('5005.amount') + index"
                    :label="$t('5005.amount')" :rules="{ required: false, decimal: true }" v-model="Payment['Amount']"
                    @keyup="ChangePercentage(index)" />
                </b-col>
                <b-col xl="1" lg="1" md="1" sm="1" cols="1">
                  <TextField :name="$t('5005.noOfDays') + index" :id="$t('5005.noOfDays') + index"
                    :label="$t('5005.noOfDays')" :rules="{ required: false, decimal: true }"
                    v-model="Payment['NoOfDays']" @keyup="" />
                </b-col>
                <b-col xl="1" lg="1" md="1" sm="1" cols="1" class="mt-4" v-if="index != MultiplePayment.length - 1">
                  <!-- <i class="editicon pi pi-pencil me-2" @click=""></i> -->
                  <i class="deleteicon pi pi-trash" @click="deletePayment(index)"></i>
                </b-col>
                <b-col xl="1" lg="1" md="1" sm="1" cols="1" class="mt-4" v-if="index == MultiplePayment.length - 1">
                  <i class="pi pi-plus" style="color: #088a1e; cursor: pointer" @click="addPayment()">
                    Add</i>
                </b-col>
              </b-row>
              <b-row class="p-3" v-if="cardshow">
                <b-col>
                  <h6>{{ $t("5005.DeliveryTerms") }}</h6>
                  <div class="contentbg" v-if="!EditSupDet">
                    <p>{{ removeHtmlTags(SupformData.DeliveryTermsName) }}</p>
                  </div>
                  <div class="label-d-none field" v-else>
                    <!-- <TextEditor v-model="SupformData.DeliveryTermsName" name="deliveryTextarea" label=""
                      :rules="{ required: false }" id="deliveryTextarea" ref="deliveryTextarea" /> -->

                    <Textarea name="deliveryTextarea" label="" :rules="{ required: false }" id="deliveryTextarea"
                      v-model="SupformData.DeliveryTermsName" />
                  </div>
                </b-col>
              </b-row>
              <b-row class="p-3" v-if="cardshow">
                <b-col>
                  <h6>{{ $t("5005.WarrantyTerms") }}</h6>
                  <div class="contentbg" v-if="!EditSupDet">
                    <p>{{ removeHtmlTags(SupformData.WarrantyTermsName) }}</p>
                  </div>
                  <div class="label-d-none field" v-else>
                    <!-- <TextEditor v-model="SupformData.WarrantyTermsName" name="warrantyTextarea" label=""
                      :rules="{ required: false }" id="warrantyTextarea" ref="warrantyTextarea" /> -->

                    <Textarea name="warrantyTextarea" label="" :rules="{ required: false }" id="warrantyTextarea"
                      v-model="SupformData.WarrantyTermsName" />
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="SupplierCardgst p-3 mt-3">
              <b-row>
                <b-col class="d-flex align-items-center">
                  <span>{{ $t("5005.gst") }}:</span>
                  <span>{{ Data.GST }}</span>
                </b-col>
                <b-col class="d-flex flex-row-reverse" v-if="Data.GST !== ''">
                  <p class="mb-0">
                    <i ref="copyButton" class="pi pi-copy copyicon" v-b-tooltip="{
                      title: tooltipContent,
                      triggers: ['hover', 'focus'],
                    }" @click="copyGST"></i>
                  </p>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>

  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, reactive, watch } from "vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../components/FormComponents/Dropdown.vue";
import Datepicker from "../../../../components/FormComponents/DatePicker.vue";
import service from "../../Service/SupplierMaster";
import RateContractService from "../../../../modules/Inventory/Service/RateContractService";
import { useToast } from "primevue/usetoast";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import DeliveryTermsService from "../../../../modules/Inventory/Service/DeliveryTermsService";
import WarrantyTermsService from "../../../../modules/Inventory/Service/OtherTermsService";
import TextEditor from "../../../../components/FormComponents/TextEditor.vue";
import Textarea from "../../../../components/FormComponents/TextArea.vue";
import AddButton from "../../../../components/GeneralButtons/AddButton.vue";
import POPaymentTermsDetailsServices from "../../../../modules/Inventory/Service/POPaymentTermsDetails";

export default defineComponent({
  components: {
    Textarea,
    TextField,
    CustomDropdown,
    Datepicker,
    TextEditor,
  },

  props: {
    showone: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    storeDetails: {
      type: Object,
      default: {},
    },
    supplierDeatails: {
      type: Object,
      default: {},
    },
    commonItemProps: {
      type: Object,
      default: {},
    },
    cardshow: {
      type: Boolean,
      default: true,
    },
    value: {},
    IsSupEdit: {
      type: Number,
      default: 0,
    },
    GrossAmount: {
      type: Number,
      default: 0.0,
    },
    MultiplePaymentList: {
      type: Object,
      default: {},
    },
  },
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();
    const showText = ref(false);
    const SupplierCard = ref(false);
    const tooltipContent = ref("Copy GST");
    const supDisabled = ref(false);
    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    const EditSupDet = ref(false);

    let ItemsBySupplierId = reactive([]);
    const form = ref({});

    var supcategory = ref();
    var paymentcategory = ref();
    var deliverycategory = ref();

    let WarrantyTermsOption = ref();
    let StockTransId = route.query.StockTransId ?? 0;
    let data1;
    let displayterms = ref(false);
    const Param = route.query.param;

    watch(
      () => props.value,
      (newVal) => {
        debugger;
      }
    );

    watch(
      () => props.GrossAmount,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          debugger;
          GrossAmount.value = newVal;
          GrossAmountFunction();
        }
      }
    );
    watch(
      () => props.MultiplePaymentList,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          debugger;
          MultiplePayment.value = newVal;
        }
      }
    );
    const GrossAmount = ref(0.0);

    const Data = reactive({
      Address: "",
      Paymentterms: "",
      deliveryterms: "",
      suppliername: "",
      GST: "",
    });

    let SupformData = reactive({
      SupplierId: ref(),
      SupplierName: "",
      CountryId: 0,
      StateId: 0,
      CityId: 0,
      PaymentTermsId: ref(),
      DeliveryTermsId: ref(),
      AdditionalTerms: "",
      Reference: "",
      BillingAddress: "",
      Email: "",
      PaymentTermsName: "",
      DeliveryTermsName: "",
      WarrantyTermsId: ref(),
      WarrantyTermsName: "",
    });

    watch(
      () => SupformData.SupplierId,
      (newVal) => {
        debugger;
        if (newVal) {
          //SupplierCard.value = true;
          if (supcategory.value != null && SupformData.SupplierId != null) {
            getfindonedata();
          }
        }
      }
    );

    watch(props, (newValue) => {
      debugger;
      if (newValue)
        if (newValue.supplierDeatails.length != undefined)
          SupformData.SupplierId = newValue.supplierDeatails[0]["SupplierId"];
      // getfindonedata();
    });

    onMounted(() => {
      if (StockTransId == 0) {
        addPayment();
      } else {
        getPaymentTerms();
      }
      ReadyFunction();
    });

    async function ReadyFunction() {
      debugger;
      Object.assign(SupformData, props.value);
      if (Param == "PO" || Param == "POAmendment") {
        loadPaymentTerms();
        loadDeliveryTerms();
        LoadWarrantyTerms();
      }

      update();

      const copyButton = document.querySelector(".pi-copy");
      if (copyButton) {
        copyButton.addEventListener("focus", () => {
          tooltipContent.value = "Click to copy";
        });
        copyButton.addEventListener("mouseleave", () => {
          tooltipContent.value = "Copy GST";
        });
      }
    }

    function update() {
      emit("update:modelValue", SupformData);
    }

    async function getfindonedata() {
      debugger;
      try {
        debugger;
        if (SupformData.SupplierId != null) {
          if (props.commonItemProps.POTypeEntityId != 0) {
            let SupplierName = supcategory.value.filter(
              (item) => item.Id == SupformData.SupplierId
            );
            console.log(SupplierName);
            console.log(SupplierName[0].name);
            SupformData.SupplierName = SupplierName[0].name;
            SupformData.CountryId = SupplierName[0].Country;
            SupformData.StateId = SupplierName[0].State;
            SupformData.CityId = SupplierName[0].City;
            SupformData.Email = SupplierName[0].Email;

            if (props.IsSupEdit == 0) {
              SupformData.BillingAddress = SupplierName[0].AddressVar;
              SupformData.AdditionalTerms = SupplierName[0].AdditionalTerms;
              SupformData.Reference = SupplierName[0].Reference;
            }
            debugger;
            let response = await service.EditData(SupformData.SupplierId);

            data1 = response["result"];
            console.log(data1);
            Data.Address = response["result"][0]["Address"];
            Data.GST = response["result"][0]["GSTNO"];
            if (StockTransId == 0) {
              if (MultiplePayment.value.length != 0) {
                debugger;
                MultiplePayment.value[0].PayTermsId =
                  response["result"][0]["PayTermsId"];
                MultiplePayment.value[0].Description =
                  response["result"][0]["PaymentTermsDesc"];
                (MultiplePayment.value[0].Percentage =
                  response["result"][0]["PercentageOfAdvance"] || 100),
                  (MultiplePayment.value[0].Amount = 0);
                MultiplePayment.value[0].NoOfDays =
                  response["result"][0]["NoofDays"] || "";
              }
            }
            if (props.IsSupEdit == 0) {
              SupformData.PaymentTermsName =
                response["result"][0]["PaymentTermsDesc"];
              SupformData.DeliveryTermsName =
                response["result"][0]["DeliTermsDesc"];
            }

            update();
            let StoreId = route.query.StoreId;
            let Id = route.query.Id;
            let responseitem =
              await RateContractService.getitemsbySupplierIdStoreId(
                SupformData.SupplierId,
                StoreId,
                HospitalId
              );
            ItemsBySupplierId = responseitem["result"];
            emit("item-update", ItemsBySupplierId);
            if (Param == "PO" || Param == "POAmendment") {
              displayterms.value = true;
            }
            SupplierCard.value = true;
          } else {
            SupformData.SupplierId = "";
            toast.add({
              severity: "warn",
              summary: "PO Type Required",
              detail: "Please select a valid PO Type to proceed.",
              life: 3000,
            });
          }
        } else {
          SupplierCard.value = false;
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function getPaymentTerms() {
      let POPaymentresponse =
        await POPaymentTermsDetailsServices.GetPaymentListByPoId(StockTransId);
      for (let item of POPaymentresponse["result"]) {
        MultiplePayment.value.push({
          Id: Param != "POAmendment" ? item.Id : 0,
          PayTermsId: item.PayTermsId,
          Description: item.Description,
          Percentage: item.Percentage,
          Amount: item.Amount,
          NoOfDays: item.Days,
        });
      }
      if (MultiplePayment.value.length == 0) {
        addPayment();
      }
    }
    async function suppliercategorydd() {
      debugger;
      try {
        const dataresponse = await service.GetSuppliersByStoreId(
          props.commonItemProps.storeId ?? 0,
          //  BranchId
          route.query.BranchId ?? 0
        );
        console.log(dataresponse);
        supcategory.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
        getfindonedata();
      } catch (error) {
        console.log(error);
      }
    }

    async function loadPaymentTerms() {
      debugger;
      try {
        const dataresponse = await service.getpaymentstermsdd();
        console.log(dataresponse["result"]);
        paymentcategory.value = dataresponse["result"]
          .filter(
            (items) => items.HospitalId == HospitalId && items.IsActive == 1
          )
          .map((item) => {
            item.name = item.PaymentTermsDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    function PaymentFunction(value) {
      debugger;
      if (value) {
        SupformData.PaymentTermsName = (
          paymentcategory.value.find((item) => item.Id === value) || {}
        ).name;
      }
    }

    async function loadDeliveryTerms() {
      debugger;
      try {
        const dataresponse = await DeliveryTermsService.getdata();
        console.log(dataresponse["result"]);
        deliverycategory.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId)
          .map((item) => {
            item.name = item.DeliTermsDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    function DeliveryFunction(value) {
      debugger;
      if (value) {
        SupformData.DeliveryTermsName = (
          deliverycategory.value.find((item) => item.Id === value) || {}
        ).name;
      }
    }

    async function LoadWarrantyTerms() {
      debugger;
      try {
        const dataresponse = await WarrantyTermsService.getdata();
        console.log(dataresponse["result"]);
        WarrantyTermsOption.value = dataresponse["result"]
          .filter((i1) => i1.IsActive == true && i1.HospitalId == HospitalId)
          .map((item) => {
            item.name = item.OtherTermDesc;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    function WarrantyTermsOnChange(value) {
      debugger;
      if (value) {
        SupformData.WarrantyTermsName = (
          WarrantyTermsOption.value.find((item) => item.Id === value) || {}
        ).name;
      }
    }

    const copyGST = async () => {
      debugger;
      try {
        await navigator.clipboard.writeText(Data.GST);
        console.log("Copied to clipboard:", Data.GST);
        tooltipContent.value = "Copied!";
      } catch (error) {
        console.error("Failed to copy to clipboard");
      }
    };
    function RowClick(event: any) {
      debugger;
      router.push({
        path: "/SupplierMasterDetailsView",
        query: {
          Id: SupformData.SupplierId,
          Type: "SupplierId",
        },
      });
    }

    function DeleteSupplier() {
      (SupformData.SupplierId = ""),
        (Data.Address = ""),
        (Data.GST = ""),
        (SupformData.PaymentTermsName = ""),
        (SupformData.DeliveryTermsName = "");
      SupplierCard.value = false;
      emit("DeleteSupplier");
    }

    function removeHtmlTags(input: string): string {
      return input.replace(/<\/?[^>]+>/gi, ""); // Regular expression to match HTML tags
    }
    let MultiplePayment: any = ref([]);
    const addPayment = () => {
      debugger;
      if (MultiplePayment.value.length) {
        if (props.GrossAmount === 0) {
          return toast.add({
            severity: "warn",
            summary: "Please add items",
            detail: "",
            life: 3000,
          });
        }
        if (MultiplePayment.value.at(-1).PayTermsId === 0) {
          return toast.add({
            severity: "warn",
            summary: "Choose Payment Terms",
            detail: "",
            life: 3000,
          });
        }
      }
      MultiplePayment.value.push({
        Id: 0,
        PayTermsId: 0,
        Description: "",
        Percentage: ref(null),
        Amount: ref(""),
        NoOfDays: "",
      });
    };

    function MultiplePaymentFunction(index, value) {
      debugger;
      if (value && index >= 0) {
        let paymentDetails = paymentcategory.value.find(
          (item) => item.Id === value
        );
        MultiplePayment.value[index]["Description"] =
          paymentDetails.PaymentTermsDesc;
        MultiplePayment.value[index]["NoOfDays"] = paymentDetails.NoofDays;
        MultiplePayment.value[index]["Percentage"] =
          paymentDetails.PercentageOfAdvance || 100;
        MultiplePayment.value[index]["Amount"] = GrossAmount.value
          ? (
            (MultiplePayment.value[index].Percentage / 100) *
            GrossAmount.value
          ).toFixed(2)
          : 0;
      }
      ModifiedPaymentTerm();
    }
    let deletedPayment: any = ref([]);
    function deletePayment(index) {
      if (MultiplePayment.value[index].Id != 0) {
        deletedPayment.value.push(MultiplePayment.value[index].Id);
      }
      MultiplePayment.value.splice(index, 1);
      emit("deletedPayment", deletedPayment.value);
    }
    function GrossAmountFunction() {
      debugger;
      for (let item of MultiplePayment.value) {
        item["Amount"] = (
          (item["Percentage"] / 100) *
          GrossAmount.value
        ).toFixed(2);
      }
      ModifiedPaymentTerm();
    }
    function ChangeAmount(index) {
      debugger;
      if (Number(MultiplePayment.value[index].Percentage) <= 100) {
        MultiplePayment.value[index].Amount = (
          (MultiplePayment.value[index].Percentage / 100) *
          GrossAmount.value
        ).toFixed(2);
      } else {
        toast.add({
          severity: "warn",
          summary: "Percentage should be less than 100",
          detail: "",
          life: 3000,
        });
        MultiplePayment.value[index].Percentage = 100;
        ChangeAmount(index);
      }
      ModifiedPaymentTerm();
    }
    function ChangePercentage(index) {
      debugger;
      if (
        Number(MultiplePayment.value[index].Amount) <= Number(GrossAmount.value)
      ) {
        MultiplePayment.value[index].Percentage =
          (MultiplePayment.value[index].Amount / GrossAmount.value) * 100;
      } else {
        toast.add({
          severity: "warn",
          summary: "Amount should be less than PO Amount",
          detail: "",
          life: 3000,
        });
        MultiplePayment.value[index].Amount = GrossAmount.value;
        ChangePercentage(index);
      }
      ModifiedPaymentTerm();
    }
    function ModifiedPaymentTerm() {
      emit("MultiplePayment", MultiplePayment.value);
    }

    return {
      removeHtmlTags,
      EditSupDet,
      Data,
      form,
      update,
      SupformData,
      getfindonedata,
      paymentcategory,
      deliverycategory,
      WarrantyTermsOption,
      supcategory,
      suppliercategorydd,
      copyGST,
      RowClick,
      showText,
      tooltipContent,
      SupplierCard,
      DeleteSupplier,
      supDisabled,
      displayterms,
      PaymentFunction,
      MultiplePaymentFunction,
      DeliveryFunction,
      WarrantyTermsOnChange,
      Param,
      MultiplePayment,
      addPayment,
      deletePayment,
      ChangeAmount,
      ChangePercentage,
    };
  },
  created() {
    this.suppliercategorydd();
  },
});
</script>
<style lang="scss" scoped>
.SupplierCard {
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  background-color: #fff;
  // width: -webkit-fill-available;
  flex: 1;
}

.SupplierCardgst {
  background-color: rgb(250, 250, 250);
}

.SupplierCardgst .pi {
  display: none;
}

.SupplierCardgst:hover .pi {
  display: block;
}

.copyicon {
  cursor: pointer !important;
}

.suppliercardcontent .pi-external-link {
  display: none;
}

.suppliercardcontent:hover .pi-external-link {
  display: block;
}

.contentbg {
  background-color: #f5f5f5;
  padding: 10px;
  font-size: 14px;
  color: #999999;
}
</style>
